import React, { useEffect } from 'react';
import { ReactComponent as MuteWrapSVG } from '../../Images/buttons/muteButtonBase.svg';
import { ReactComponent as MuteWrapOverSVG } from '../../Images/buttons/muteButtonBaseOver.svg';
import { ReactComponent as MuteIndiSVG } from '../../Images/buttons/muteButtonIndicator.svg';
import { ReactComponent as MuteBackSVG } from '../../Images/buttons/muteButtonBack.svg';
import { useRecoilState } from 'recoil';
import { mouthShapeAtom } from '../../../State';
import KUTE from 'kute.js';

export const MuteButton = ({ isMouseOver }) => {
  const [mouthState] = useRecoilState(mouthShapeAtom);

  useEffect(() => {
    let mouthValue = 0;

    if (mouthState < 3) {
      mouthValue = '50%';
    } else if (mouthState < 5) {
      mouthValue = '40%';
    } else if (mouthState < 10) {
      mouthValue = '30%';
    } else if (mouthState < 15) {
      mouthValue = '20%';
    } else if (mouthState < 20) {
      mouthValue = '10%';
    } else if (mouthState < 25) {
      mouthValue = '0%';
    } else if (mouthState < 30) {
      mouthValue = '0%';
    }

    // if (mouthState < 40) {
    //   mouthValue = '50%';
    // } else if (mouthState < 50) {
    //   mouthValue = '40%';
    // } else if (mouthState < 60) {
    //   mouthValue = '30%';
    // } else if (mouthState < 70) {
    //   mouthValue = '20%';
    // } else if (mouthState < 80) {
    //   mouthValue = '10%';
    // } else if (mouthState < 90) {
    //   mouthValue = '0%';
    // } else if (mouthState < 100) {
    //   mouthValue = '0%';
    // }

    KUTE.fromTo(
      '#muteIndi',
      { top: mouthValue },
      { top: '70%' },
      { duration: 500, easing: 'easingCubicIn' },
    ).start();
  }, [mouthState]);

  return (
    <>
      <div id="muteWrap">
        {!isMouseOver ? <MuteWrapSVG id="muteBase" /> : <MuteWrapOverSVG id="muteBase" />}
        <MuteBackSVG id="muteBack" />
        <div id="muteIndi">
          <MuteIndiSVG />
        </div>
      </div>
    </>
  );
};
